import usePrivateAxios from "@/common/api/usePrivateAxios";
import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { EquipmentModelResponse, EquipmentModelData } from "../types/equipmentModels";

const useEquipmentModel: (id: string) => UseQueryResult<EquipmentModelData, unknown> = (id) => {
  const privateAxios = usePrivateAxios()

  return useQuery<EquipmentModelResponse, unknown, EquipmentModelData>({
    queryKey: ['equipmentModel', id],
    queryFn: () => privateAxios.get(`/equipment_models/${id}`),
    select: (data) => data?.data?.data
  });
}

export default useEquipmentModel